import React, { memo, useCallback } from "react";

import { NumberField } from "ui/components/TextField/NumberField";

import { SubscriptionEstimateInputsProps } from "../../types";

/**
 * Unos za procjenu. Novi klijent nema ni vozila ni potrošnje, pa očekivane brojke unosi
 * predstavnik — one nigdje ne ulaze u potpis, služe samo da se vidi iznos.
 */
const SubscriptionEstimateInputs: React.FC<SubscriptionEstimateInputsProps> = (props) => {
  const { vehicleCount, meteredKeys, quantities, onVehicleCountChange, onQuantityChange } =
    props;

  // Procjena računa s brojevima, pa prazno polje ovdje znači nulu.
  const handleVehicleCountChange = useCallback(
    (value: number | null) => {
      onVehicleCountChange(value ?? 0);
    },
    [onVehicleCountChange]
  );

  const handleQuantityChange = useCallback(
    (value: number | null, name?: string) => {
      if (!name) return;

      onQuantityChange(name, value ?? 0);
    },
    [onQuantityChange]
  );

  return (
    <div>
      <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold mb-1">
        Očekivani opseg
      </h3>
      <p className="text-xs text-slate-500 mb-3">
        Služi samo za procjenu iznosa. Ne sprema se i ne ulazi u pretplatu.
      </p>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <NumberField
            name="estimatedVehicles"
            label="Broj vozila"
            size="full"
            decimals={0}
            min={0}
            value={vehicleCount}
            onChange={handleVehicleCountChange}
          />
        </div>

        {meteredKeys.map((key) => (
          <div key={key.code}>
            <NumberField
              name={key.code}
              label={`${key.name} — mjesečno`}
              size="full"
              decimals={0}
              min={0}
              value={quantities[key.code] ?? null}
              onChange={handleQuantityChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(SubscriptionEstimateInputs);
